import { FormOutline } from "./FormOutline";
import { LanguagePicker } from "./LanguagePicker";
import { TextLine } from "features/common/TextLine";
import { SidePanelTextLine } from "features/common/SidePanelTextLine";

import { selectFormType } from "features/qualityForm/qualityFormSlices/qualityFormCommons";
import FormType from "enums/FormType";
import { useAppSelector } from "app/hooks";

import { EvaluationAssistanceSummary } from "./EvaluationAssistanceSummary";
import { AiScoringSummary } from "./AiScoringSummary";

import "./Content.less";

export function Content() {
    const formType = useAppSelector(selectFormType);

    return (
        <div className="ContentPanel">
            {formType === FormType.SURVEY && (
                <>
                    <LanguagePicker />
                    <TextLine />
                </>
            )}
            {formType === FormType.EVALUATION && (
                <>
                    <AiScoringSummary />
                    <SidePanelTextLine />
                    <EvaluationAssistanceSummary />
                    <SidePanelTextLine />
                </>
            )}
            <FormOutline />
        </div>
    );
}
